import { lazy } from "react";
import type { RouteConfig } from "../config";
import { ROUTES } from "../paths";

const AutomationsPage = lazy(() => import("@/pages/automations").then((m) => ({ default: m.AutomationsPage })));
const AutomationDetailPage = lazy(() => import("@/pages/automations").then((m) => ({ default: m.AutomationDetailPage })));
const AutomationNewPage = lazy(() => import("@/pages/automations").then((m) => ({ default: m.AutomationNewPage })));

// Sem a feature a rota não existe (como o menu e a API): devolve ao painel. A entidade é a mesma que o servidor declara.
const READ = { access: "permission" as const, entity: "automations", action: "READ", feature: "platform.automations" as const };
const CREATE = { access: "permission" as const, entity: "automations", action: "CREATE", feature: "platform.automations" as const };

export const automationRoutes: RouteConfig[] = [
  { path: ROUTES.AUTOMATIONS.MAIN, component: AutomationsPage, layout: "dashboard", permissions: READ },
  // `/new` antes de `/:automationId`: o construtor nunca se confunde com um detalhe.
  { path: ROUTES.AUTOMATIONS.NEW, component: AutomationNewPage, layout: "dashboard", permissions: CREATE },
  { path: ROUTES.AUTOMATIONS.DETAIL, component: AutomationDetailPage, layout: "dashboard", permissions: READ },
];
